import { useDialogStore } from "@/shared/stores";
import { Button } from "@spz/ui/components/button";
import { useTranslation } from "react-i18next";
import { UserGroupsForm } from "../forms/user-groups-form";

export const useCreateOrUpdateUserGroupsDialog = () => {
  const { openDialog, closeDialog } = useDialogStore();
  const { t } = useTranslation();

  return {
    open: ({ groupId }: { groupId?: string } = {}) => {
      openDialog({
        header: {
          title: t("users_group_management_title"),
        },
        content: (
          <UserGroupsForm
            className="max-h-[70vh] overflow-y-auto overscroll-y-auto overflow-x-hidden pink-scroll"
            groupId={groupId}
            onSuccess={closeDialog}
          />
        ),
        footer: {
          actions: (
            <Button type="submit" form="users-group-form">
              {groupId ? t("validate") : t("create")}
            </Button>
          ),
        },
      });
    },
  };
};
